/** @format */

import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  isShowing: false,
  isLoading: false,
  isDone: false,
  configurationId: '',
  invoiceReference: '',
  error: ''
});

export default function editInvoiceReferenceReducer(
  state = INITIAL_STATE,
  action
) {
  switch (action.type) {
    case 'SHOW_EDIT_INVOICE_REFERENCE_MODAL': {
      return state
        .set('isShowing', true)
        .set('configurationId', action.payload.configurationId)
        .set('invoiceReference', action.payload.invoiceReference);
    }
    case 'HIDE_EDIT_INVOICE_REFERENCE_MODAL': {
      return INITIAL_STATE;
    }
    case 'EDIT_INVOICE_REFERENCE_STARTED': {
      return state.set('isLoading', true);
    }
    case 'EDIT_INVOICE_REFERENCE_DONE': {
      return state.set('isLoading', false).set('isDone', true).set('error', '');
    }
    case 'EDIT_INVOICE_REFERENCE_FAILED': {
      return state.set('isLoading', false).set('error', action.payload.error);
    }
    case 'EDIT_INVOICE_REFERENCE_INPUT_CHANGE': {
      return state.set('invoiceReference', action.payload.value);
    }
    default: {
      return state;
    }
  }
}
